import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { OemComponent } from './oem.component';

const routes: Routes = Route.withShell([
  { path: 'oem', component: OemComponent, data: { title: 'OEM' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)],
  ],
  exports:[RouterModule],
  declarations: []
})
export class OemRoutingModule { }
